import '@assets/main.css'
import '@assets/chrome-bug.css'
// import 'keen-slider/keen-slider.min.css'

import 'rc-slider/assets/index.css'
import '@assets/custom-rc-slider.css'
import '@assets/custom-rec-carousel.css'
import '@assets/custom-newsletter-form.css'
import '@assets/custom-inova-icon.css'
import '@assets/yd-breadcrumbs.css'
import '@assets/custom-slick-dots.css'

import { FC, useEffect } from 'react'
import type { AppProps } from 'next/app'
import Script from 'next/script'
import Head from '@components/common/Head/Head'
import { ManagedUIContext } from '@components/ui/context'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false

const Noop: FC = ({ children }) => <>{children}</>

export default function MyApp({ Component, pageProps }: AppProps) {
  const Layout = (Component as any).Layout || Noop

  useEffect(() => {
    document.body.classList?.remove('loading')
  }, [])

  return (
    <>
      <Head />
      <ManagedUIContext>
        <Layout pageProps={pageProps}>
          <Component {...pageProps} />
        </Layout>
      </ManagedUIContext>

      {/* <!-- Google Tag Manager --> */}
      <Script
        id="gtm"
        strategy="lazyOnload"
        defer
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.gtmContainerId}');`,
        }}
      />
      {/* <!-- End Google Tag Manager --> */}

      {/* <!-- Google tag (gtag.js) --> */}
      <Script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.gaMeasurementId}`}
        strategy="afterInteractive"
      />
      <Script
        id="gtag"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', '${process.env.gaMeasurementId}');`,
        }}
      />

      {/* VTO */}
      {process.env.nextEnv === 'production' ? (
        <Script src="https://rtr.vto.jewelry/?d=PN6XKM4" strategy='lazyOnload' />
      ) : (
        <Script src="https://rtr.vto.jewelry/?d=PN6XKM4"  strategy='lazyOnload' />
      )}

      {/* <!-- Start of HubSpot Embed Code --> */}
      {(process.env.nextEnv === 'production' || process.env.nextEnv === 'stage') &&
      <Script
        id="hs-script-loader"
        src={`//js.hs-scripts.com/${process.env.hubspotTrackingId}.js`}
        strategy="lazyOnload"
      />}
      {/* <!-- End of HubSpot Embed Code --> */}
    </>
  )
}
